module.exports = __webpack_public_path__ + "img/print.44c6b638.svg";